import * as React from "react";
import BaseWSTmp from "./base-ws-tmp";
// 订单更新时推送的消息

interface IOrderUpdWSTmpProps {
  // 订单号
  orderNumber?: any;
  // 跳转链接
  dataUrl?: any;
  // 出行日期
  goTime?: any;
  // 订单状态
  orderStatus?: any;
}

class OrderUpdWSTmp extends React.Component<IOrderUpdWSTmpProps, any> {
  constructor(props: IOrderUpdWSTmpProps) {
    super(props);
  }

  // 获取订单更新时的消息模板
  getContent = () => {
    const { orderNumber, dataUrl, goTime, orderStatus } = this.props;
    return (
      <div className="orderUpd-notice">
        <div>
          你的订单
          <a href={dataUrl} target="_blank">
            {orderNumber}
          </a>
          ，出发日期
          <a href="javascript:void(0)">{goTime}</a>
          ，供应商更新了订单状态为
          <a href="javascript:void(0)">{orderStatus}</a>， 请及时处理。
        </div>
      </div>
    );
  };

  render() {
    return <BaseWSTmp {...this.props} slot={this.getContent()} />;
  }
}

export default OrderUpdWSTmp;
